import { render, staticRenderFns } from "./user-manage.vue?vue&type=template&id=1292dd1c&scoped=true&"
import script from "./user-manage.vue?vue&type=script&lang=js&"
export * from "./user-manage.vue?vue&type=script&lang=js&"
import style0 from "./user-manage.vue?vue&type=style&index=0&id=1292dd1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1292dd1c",
  null
  
)

export default component.exports